/**
 * A coordinate pair the map can actually plot, or null.
 *
 * Leaflet throws on a NaN latitude — `Invalid LatLng object: (NaN, NaN)` — and
 * it throws from inside L.latLngBounds, during render, so one bad row takes the
 * whole case page down rather than losing a pin.
 *
 * The guards this replaces were a list of the specific strings someone had
 * seen: `"-"` and `"undefined"`, plus a truthiness check. Anything else the
 * backend sends for "no GPS" — "null", "N/A", "nan", an empty object, a
 * latitude that parses but is out of range — went straight to parseFloat and
 * came back NaN. This asks the only question that matters: is it a finite
 * number in range?
 *
 * Kept pure and free of leaflet so it can be unit-tested; this runner cannot
 * load the map component itself.
 */
export const toLatLng = (lat, lng) => {
  const latitude = Number.parseFloat(lat);
  const longitude = Number.parseFloat(lng);

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
  if (latitude < -90 || latitude > 90) return null;
  if (longitude < -180 || longitude > 180) return null;

  return [latitude, longitude];
};

/** True when this row carries a plottable position. */
export const hasLatLng = (item) =>
  toLatLng(item?.lat, item?.longitude) !== null;

export default toLatLng;
